'use strict';

angular.module('shop').controller('SimpleCheckoutController', function($rootScope, $scope, $window, ShopService, PointsService, CustomerService, Toast, LANG) {
	$scope.cart = ShopService.getCart();

	if (!$scope.cart ||  $scope.cart.cartArticles.length === 0) {
		$scope.emptyCart = true;
		return;
	}

	$scope.loading = true;

	$scope.input = {};

	if ($scope.cart.giftCode || $scope.cart.giftCode !== '') {
		$scope.input.giftcard = $scope.cart.giftCode;
	}

	PointsService.get().then(function(points) {
		var total = points * 0.02;
		var price = Math.floor(total);
		$scope.points = points;
		$scope.pointsPrice = price;
	});

	CustomerService.get().then(function (customer) {
		$scope.cart.customerID = customer.id;

		$scope.getSummary(false);
	});

	$scope.getSummary = function(useLoyaltyPoints) {
		$scope.loading = true;

		$scope.cart.useLoyaltyPoints = useLoyaltyPoints;

		ShopService.getSummary($scope.cart).then(function(summary) {

			if (!summary.summaryArticles || summary.summaryArticles.length === 0) {
				$scope.emptyCart = true;
				$scope.loading = false;
				return;
			}

			if (summary.summaryArticles && summary.summaryArticles.length > 0) {
				_.each(summary.summaryArticles, function(article) {
					article.product = _.find($scope.cart.cartArticles, {shopArticleID: article.shopArticleID});
				});
			}

			if (summary.giftCodePrice > 0) {
				$scope.giftcard = true;
			}

			summary.formatedDeliveryDate = moment(summary.deliveryDate).locale(LANG).format('dddd D MMMM');

			$scope.summary = summary;
			$scope.loading = false;
		});
	};

	$scope.removeArticle = function(article) {
		var articleIndex = _.findIndex($scope.cart.cartArticles, {shopArticleID: article.shopArticleID});

		if (articleIndex !== -1) {
			$scope.cart.cartArticles.splice(articleIndex, 1);

			ShopService.setCart($scope.cart);
		}
	};

	$scope.useGiftCard = function(code) {
		$scope.cart.giftCode = code;
		ShopService.setCart($scope.cart);
	};

	$scope.removeGiftcard = function() {
		$scope.cart.giftCode = '';
		$scope.input.giftcard = '';
		$scope.giftcard = false;
		ShopService.setCart($scope.cart);
	};

	$scope.order = function() {
		$scope.sentOrder = true;

		ShopService.order($scope.cart).then(function() {
			$scope.sentOrder = false;
			$scope.emptyCart = true;
			$rootScope.$emit('shop-cart.update');
			Toast.successContent('<i class="mk-icon mk-icon-share mk-icon-x5"></i><h2 class="mt-md">Du hittar en sammanställning under aktuell leveransvecka på Min meny. Vi har även skickat en orderbekräftelse till din e-post.</h2>', '/mypage/', 5000);
		});
	};

	$rootScope.$on('shop-cart.update', function() {
		$scope.getSummary($scope.useGiftCard);
	});

});
